'use client'

import clsx from 'clsx'
import React from 'react'

interface TabListProps {
	reversedTabs?: boolean
	nowrap?: boolean
	children: React.ReactNode
	className?: string
}

export const TabList = (props: TabListProps) => {
	return (
		<div
			className={clsx('flex gap-y-2 gap-x-6 mb-2.5', {
				'flex-row flex-wrap': !props.nowrap,
				'flex-row-reverse': props.reversedTabs,
				[props.className!]: props.className,
			})}
		>
			{props.children}
		</div>
	)
}
